// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f-","border":"f_"};